import { render, staticRenderFns } from "./CertificateEducationItem.vue?vue&type=template&id=ec1b7b86&scoped=true"
import script from "./CertificateEducationItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CertificateEducationItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CertificateEducationItem.vue?vue&type=style&index=0&id=ec1b7b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1b7b86",
  null
  
)

export default component.exports